import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { BasketProductViewModel } from '@models/api-search.models';
import { BrandLinkPipe } from './brand-link.pipe';
import { RouterLink } from '@angular/router';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-brand-link',
    templateUrl: './brand-link.component.html',
    styleUrls: ['./brand-link.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, RouterLink, AsyncPipe, BrandLinkPipe]
})
export class BrandLinkComponent {
    @HostBinding('class') class = 'brand';
    @HostBinding('class.compact') get isCompact() {
        return this.compact;
    }

    @Input() compact: boolean = false;
    @Input() brand: BasketProductViewModel['brand'];
}
